export const ERROR_HANDLER = '[ErrorHandler]';

export const SET_ERROR_HANDLER_INITIALIZED = `${ERROR_HANDLER} SET_ERROR_HANDLER_INITIALIZED`;
